import { render, staticRenderFns } from "./WeeklyBookingsChart.vue?vue&type=template&id=6cf4ffd4&"
import script from "./WeeklyBookingsChart.vue?vue&type=script&lang=js&"
export * from "./WeeklyBookingsChart.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyBookingsChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports